import { render, staticRenderFns } from "./BottomDrawer.vue?vue&type=template&id=83d510ca&"
import script from "./BottomDrawer.vue?vue&type=script&lang=js&"
export * from "./BottomDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BottomDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports